import { connect, mapProps } from '@formily/vue'

import type { Switch as ElSwitchProps } from '@didi-pebble/pebble-design-vue'
import { Switch as ElSwitch } from '@didi-pebble/pebble-design-vue'

export type SwitchProps = ElSwitchProps

export const Switch = connect(ElSwitch, mapProps({ readOnly: 'readonly' }))

export default Switch
